import React, { memo, useCallback, useState } from 'react';
import { Avatar } from '@app/components';
import { cn } from 'lib/utils';

interface Props {
  className?: string;
  size?: number;
  borderRadius?: number;
  avatarFiles?: string;
  editable?: boolean;
  onSubmit?: (file: File) => void;
  customPlaceholder?: string;
}

function ProfileAvatar(props: Props) {
  const {
    onSubmit,
    avatarFiles,
    size = 244,
    borderRadius = 50,
    editable = false,
    customPlaceholder,
    className = '',
  } = props;
  const [file, setFile] = useState<File | null>(null);

  const onChangeAvatar = useCallback(
    (value: File | null) => {
      if (value) {
        setFile(value);
        onSubmit && onSubmit(value);
      }
    },
    [onSubmit]
  );

  return (
    <div
      className={cn(
        'flex items-center justify-center w-full',
        className.trim()
      )}
    >
      <Avatar
        size={size}
        src={avatarFiles}
        customPlaceholder={customPlaceholder}
        value={file}
        onChange={onChangeAvatar}
        editable={editable}
        borderRadius={borderRadius}
      />
    </div>
  );
}

export default memo(ProfileAvatar);
